/**
 * Tiny Mantine Switch wired to the InlineEditing context.
 *
 * Used in the MRT toolbar above each table — the toggle scopes to the
 * grid where it lives, but the underlying state is global (the
 * InlineEditingProvider sits at the app shell level), so flipping it
 * here also affects any other table view.
 */
import { Switch } from "@mantine/core";
import { useInlineEditing } from "../lib/inline-editing";

export function InlineEditingSwitch() {
  const { enabled, setEnabled } = useInlineEditing();
  return (
    <Switch
      size="xs"
      checked={enabled}
      onChange={(e) => setEnabled(e.currentTarget.checked)}
      label="Inline editing"
      labelPosition="left"
      styles={{
        label: {
          fontSize: "var(--t-sm)",
          color: "var(--fg-muted)",
          paddingRight: 8,
          whiteSpace: "nowrap",
        },
      }}
    />
  );
}
